import React from "react";
import { cn } from "@/utils";

interface InitialsAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  firstName?: string;
  lastName?: string;
  fullName?: string;
  size?: number;
}

export const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  firstName = "",
  lastName = "",
  fullName,
  size = 24,
  className,
  ...props
}) => {
  const getInitials = () => {
    // If fullName is provided, extract from it
    if (fullName) {
      const names = fullName.trim().split(" ").filter(Boolean);
      const first = names[0] ?? "";
      const last = names[names.length - 1] ?? "";
      if (names.length === 0) return "?";
      if (names.length === 1) return first.charAt(0).toUpperCase();
      return (first.charAt(0) + last.charAt(0)).toUpperCase();
    }
    // Otherwise use firstName and lastName
    const firstInitial = firstName?.charAt(0)?.toUpperCase() || "";
    const lastInitial = lastName?.charAt(0)?.toUpperCase() || "";
    const initials = firstInitial + lastInitial;

    return initials || "?";
  };

  return (
    <div
      className={cn(
        "flex items-center justify-center bg-border-secondary text-text-secondary font-medium rounded-full",
        className,
      )}
      style={{
        width: size * 2,
        height: size * 2,
        fontSize: size * 0.8,
        minWidth: size * 2,
        minHeight: size * 2,
      }}
      {...props}
    >
      {getInitials()}
    </div>
  );
};
